export default "__VITE_ASSET__DXmNL0qA__"